import React, { useEffect, useState } from "react";
import { useSubheader } from "@metronic/layout";
import { Alert } from "react-bootstrap";
import GeneralFilter from "@components/shared/general-filter";
import Pagination from "react-js-pagination";
import { getCasesByStatuses } from "@services/cases";
import GeneralTable from "@components/shared/general-table";
import CaseContext from "@contexts/case-context";
import { IfHasRoleByLocalStorage } from "@metronic/_helpers";
import { CASE_STATUS } from "@constants/case-statuses";

// Casos que salen de Control de Costos y esperan el seguimiento de Concierge antes del Alta.
const CONCIERGE_STATUSES = [CASE_STATUS.CONCIERGE];

const Concierge = () => {
  window.currModule = "Concierge";

  const subheader = useSubheader();

  const [casesRecord, setCasesRecord] = useState([]);
  const [paramsPagination, setParamsPagination] = useState({
    activePage: 1,
    totalPages: null,
    itemsCountPerPage: null,
    totalItemsCount: 0,
  });

  const getAllCasesByStatus = (pageNumber) => {
    if (CONCIERGE_STATUSES.length === 0) {
      return;
    }

    var queryParams = [];

    if (IfHasRoleByLocalStorage("ADMIN_REGION_CELULA")) {
      queryParams = ['&byRegion=true', '&byCell=true'];
    }

    getCasesByStatuses(CONCIERGE_STATUSES, pageNumber, queryParams).then((response) => {
      setCasesRecord(response.data);

      setParamsPagination({
        activePage: pageNumber,
        totalPages: response.totalPages,
        itemsCountPerPage: response.size,
        totalItemsCount: response.totalElements,
      });
    });
  }

  const handlePageChange = async (pageNumber) => {
    setParamsPagination({ ...paramsPagination, activePage: pageNumber, updatePage: true });

    if (!paramsPagination.hasOwnProperty("fromFilter")) {
      getAllCasesByStatus(pageNumber);
    }
  }

  useEffect(() => {
    getAllCasesByStatus(paramsPagination.activePage);

    subheader.setTitle("Concierge")
  }, []);

  return (
    <>
      <Alert
        variant="success"
        className="text-center"
        style={{ fontSize: "16px" }}
      >
        Concierge
      </Alert>

      <CaseContext.Provider value={[
        casesRecord, setCasesRecord,
        paramsPagination, setParamsPagination
      ]}>
        <GeneralFilter
          statuses={CONCIERGE_STATUSES}
          hideInsurance={true}
          hideHospitalInvoice={true}
          hidePresumptiveDiagnosis={true}
          hideCategoryVip={true}
          hideCell={false}
          showSpecialityFilters={true}
        />
      </CaseContext.Provider>

      <GeneralTable
        urlToGo="/concierge_detalles/"
        data={casesRecord}
        activePage={paramsPagination.activePage}
        totalItemsCount={paramsPagination.totalItemsCount}
        hideAxaCategoryColumn={false}
        hidePatientStatusColumn={true}
        hideCelulaColumn={false}
        currModule="Concierge"
      />

      <div className="d-flex justify-content-center">
        <Pagination
          activePage={paramsPagination.activePage}
          itemsCountPerPage={paramsPagination.itemsCountPerPage}
          totalItemsCount={paramsPagination.totalItemsCount}
          pageRangeDisplayed={10}
          itemClass="page-item"
          linkClass="btn btn-light"
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export default Concierge;
